import Bugsnag, { NotifiableError } from '@bugsnag/js';
import { call, put, select } from 'redux-saga/effects';

import { send, sendError, sendSuccess } from '../../slices/leadMagnetForm';
import { RootState } from '../../store';
import leadMagnetFormFetcher from './leadMagnetFormFetcher';

export default function* leadMagnetFormWorker(action: ReturnType<typeof send>) {
  try {
    const phone: string = yield select((state: RootState) => {
      return state.user.phone.value;
    });

    const response: Response = yield call(leadMagnetFormFetcher, {
      'email': action.payload.email,
      'leadMagnetId': action.payload.id,
      'nombre': action.payload.name,
      'telefono': phone,
      'recaptcha-token': action.payload.recaptchaToken,
      'regionId': action.payload.regionId,
      'communeId': action.payload.communeId,
      'acceptNewsletter': action.payload.acceptNewsletter,
      'empresa': action.payload.companyName,
      'profile': action.payload.profile
    });

    if (!response.ok) {
      throw new Error('errors:unknownError');
    }

    if (window && window.dataLayer) {
      yield call(() => {
        return new Promise((resolve) => {
          window.dataLayer.push({
            event: 'marketing_lead',
            type: action.payload.profile,
            leadMagnetId: action.payload.id,
            ...(action.payload.regionName && {
              region: action.payload.regionName
            }),
            ...(action.payload.communeName && {
              commune: action.payload.communeName
            }),
            eventCallback: resolve
          });
        });
      });

      if (action.payload.formRedirectUrl) {
        window.location.href = action.payload.formRedirectUrl;
      } else {
        yield put(sendSuccess());
      }
    }
  } catch (error) {
    Bugsnag.notify(error as NotifiableError);

    let message = 'errors:unknownError';

    if (error instanceof Error) {
      message = error.message;
    }

    yield put(sendError(message));
  }
}
